import { cn } from '../utils/cn';

interface FeatureChipProps {
  title: string;
  description: string;
  icon: string;
  className?: string;
}

/**
 * Feature Chip Component
 *
 * Displays a feature with an icon, title, and description.
 */
export const FeatureChip: React.FC<FeatureChipProps> = ({
  title,
  description,
  icon,
  className,
}) => {
  return (
    <div
      className={cn(
        'flex items-start space-x-2 glass-card-bg glass-card-border rounded-2xl p-4',
        className
      )}
    >
      <div className="flex-shrink-0 h-full flex items-center justify-center">
        <img src={icon} alt={title} className="w-8 h-8" />
      </div>
      <div className="flex-1 flex flex-col">
        <h3 className="text-text-one text-[12px] font-semibold">{title}</h3>
        <p className="text-foreground text-[11px] leading-relaxed">{description}</p>
      </div>
    </div>
  );
};
